import { useDataValue } from 'Simple/Data.js'

export default function useDataConfiguration(props) {
  let id = useDataValue({
    context: 'form',
    path: 'action.document_id',
    viewPath: props.viewPath,
  })

  return {
    variables: {
      id,
    },
    pause: !id,
  }
}
